'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Card = exports.Col = exports.AutoAdjustedRow = exports.AutoAdjustedColumns = exports.Row = exports.Columns = exports.RawContainer = exports.Container = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Grid = require('./Grid.scss');

var _Grid2 = _interopRequireDefault(_Grid);

var _Card = require('../Card');

var _Card2 = _interopRequireDefault(_Card);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RawContainer = function (_Component) {
  _inherits(RawContainer, _Component);

  function RawContainer() {
    _classCallCheck(this, RawContainer);

    return _possibleConstructorReturn(this, (RawContainer.__proto__ || Object.getPrototypeOf(RawContainer)).apply(this, arguments));
  }

  _createClass(RawContainer, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: _Grid2.default['raw-container'] },
        this.props.children
      );
    }
  }]);

  return RawContainer;
}(_react.Component);

RawContainer.propTypes = {
  children: _propTypes2.default.node
};

var Container = function (_Component2) {
  _inherits(Container, _Component2);

  function Container() {
    _classCallCheck(this, Container);

    return _possibleConstructorReturn(this, (Container.__proto__ || Object.getPrototypeOf(Container)).apply(this, arguments));
  }

  _createClass(Container, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: _Grid2.default.wixContainer },
        this.props.children
      );
    }
  }]);

  return Container;
}(_react.Component);

Container.propTypes = {
  children: _propTypes2.default.node
};

var Columns = function (_Component3) {
  _inherits(Columns, _Component3);

  function Columns() {
    _classCallCheck(this, Columns);

    return _possibleConstructorReturn(this, (Columns.__proto__ || Object.getPrototypeOf(Columns)).apply(this, arguments));
  }

  _createClass(Columns, [{
    key: 'render',
    value: function render() {
      var _classNames;

      var rowClasses = (0, _classnames2.default)(_Grid2.default.row, this.props.className, (_classNames = {}, _defineProperty(_classNames, _Grid2.default.rtl, this.props.rtl), _defineProperty(_classNames, _Grid2.default.stretch_vertically_row, this.props.stretchViewsVertically), _classNames));

      return _react2.default.createElement(
        'div',
        { className: rowClasses, 'data-hook': this.props.dataHook },
        this.props.children
      );
    }
  }]);

  return Columns;
}(_react.Component);

Columns.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  rtl: _propTypes2.default.bool,
  stretchViewsVertically: _propTypes2.default.bool,
  dataHook: _propTypes2.default.string
};
Columns.defaultProps = {
  stretchViewsVertically: false
};

var AutoAdjustedColumns = function (_Component4) {
  _inherits(AutoAdjustedColumns, _Component4);

  function AutoAdjustedColumns() {
    var _ref;

    var _temp, _this4, _ret;

    _classCallCheck(this, AutoAdjustedColumns);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this4 = _possibleConstructorReturn(this, (_ref = AutoAdjustedColumns.__proto__ || Object.getPrototypeOf(AutoAdjustedColumns)).call.apply(_ref, [this].concat(args))), _this4), _this4.DEFAULT_MAX_SPAN = 12, _temp), _possibleConstructorReturn(_this4, _ret);
  }

  _createClass(AutoAdjustedColumns, [{
    key: 'render',
    value: function render() {
      var cssClasses = (0, _classnames2.default)(_Grid2.default.row, _Grid2.default.flexContainer);
      var children = this.props.children;
      var cols = Array.isArray(children) ? children : [children];
      var spanSize = Math.floor(this.DEFAULT_MAX_SPAN / cols.length);
      return _react2.default.createElement(
        'div',
        { className: cssClasses },
        cols.map(function (child, index) {
          return _react2.default.createElement(
            Col,
            { span: spanSize, key: index },
            child
          );
        })
      );
    }
  }]);

  return AutoAdjustedColumns;
}(_react.Component);

AutoAdjustedColumns.propTypes = {
  children: _propTypes2.default.node
};

var Col = function (_Component5) {
  _inherits(Col, _Component5);

  function Col() {
    _classCallCheck(this, Col);

    return _possibleConstructorReturn(this, (Col.__proto__ || Object.getPrototypeOf(Col)).apply(this, arguments));
  }

  _createClass(Col, [{
    key: 'isVisibleHidden',
    value: function isVisibleHidden(str) {
      return str === 'hidden' || str === 'visible';
    }
  }, {
    key: 'isLegalCol',
    value: function isLegalCol(numStr) {
      if (numStr && !this.isVisibleHidden(numStr)) {
        var num = Number(numStr);
        return Number.isInteger(num) && num > 0 && num <= 12;
      }
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var columnClasses = (0, _classnames2.default)(this.props.className, _Grid2.default.column, _defineProperty({}, _Grid2.default.rtl, this.props.rtl), _defineProperty({}, _Grid2.default['colXs' + this.props.span], this.isLegalCol(this.props.span)), _defineProperty({}, _Grid2.default['colXs' + this.props.xs], this.isLegalCol(this.props.xs)), _defineProperty({}, _Grid2.default['colSm' + this.props.sm], this.isLegalCol(this.props.sm)), _defineProperty({}, _Grid2.default['colMd' + this.props.md], this.isLegalCol(this.props.md)), _defineProperty({}, _Grid2.default['colLg' + this.props.lg], this.isLegalCol(this.props.lg)), _defineProperty({}, _Grid2.default['colXl' + this.props.xl], this.isLegalCol(this.props.xl)), _defineProperty({}, _Grid2.default[this.props.xs + 'Xs'], this.isVisibleHidden(this.props.xs)), _defineProperty({}, _Grid2.default[this.props.sm + 'Sm'], this.isVisibleHidden(this.props.sm)), _defineProperty({}, _Grid2.default[this.props.md + 'Md'], this.isVisibleHidden(this.props.md)), _defineProperty({}, _Grid2.default[this.props.lg + 'Lg'], this.isVisibleHidden(this.props.lg)));
      return _react2.default.createElement(
        'div',
        { className: columnClasses, 'data-hook': this.props.dataHook },
        this.props.children
      );
    }
  }]);

  return Col;
}(_react.Component);

Col.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  span: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  rtl: _propTypes2.default.bool,
  xs: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  sm: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  md: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  lg: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  xl: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  dataHook: _propTypes2.default.string
};
Col.defaultProps = {
  span: 12
};
exports.Container = Container;
exports.RawContainer = RawContainer;
exports.Columns = Columns;
exports.Row = Columns;
exports.AutoAdjustedColumns = AutoAdjustedColumns;
exports.AutoAdjustedRow = AutoAdjustedColumns;
exports.Col = Col;
exports.Card = _Card2.default;